import { useMutation } from '@tanstack/react-query'

import { apiClient } from '../../lib/client.js'
import { quoteAuthHeaders } from './quote-token.js'

export const useDownloadPublicQuotePdfMutation = () =>
  useMutation({
    mutationFn: async (responseId: string): Promise<Blob> => {
      const response = await apiClient.client.get<Blob>(
        `/public/estimate-responses/${responseId}/pdf`,
        { headers: quoteAuthHeaders(responseId), responseType: 'blob' }
      )
      return response.data
    },
  })
